import ConfigurationsService from '../../services/configurations.service';
import PaymentService from '../../services/payments.service';

export const state = {
  creditsData: null,
  stripePublicKey: null,
  intentSecret: null,
  isEUCountry: false
};

export const actions = {
  async getCreditsAndCountryData({ commit, rootState }) {
    try {
      const { data: creditsData } = await ConfigurationsService.getFile({
        fileName: 'credits-data'
      });
      //Check user country is on the EU
      const countryId = rootState.profile.profileData.countryId;
      creditsData.EUcontries.forEach((country) => {
        if (countryId === country) {
          commit('SET_EU_COUNTRY', true);
        }
      });
      commit('SET_CREDITS_DATA', creditsData);
      return creditsData;
    } catch (error) {
      console.error(error);
    }
  },
  async getStripePublicKey({ commit }) {
    try {
      const { data: stripePublicKey } = await PaymentService.getPublicKey();
      commit('SET_STRIPE_PUBLIC_KEY', stripePublicKey);
      return stripePublicKey;
    } catch (error) {
      console.error(error);
    }
  },
  async createPaymentIntent({ commit }, intentData) {
    try {
      const { data: res } = await PaymentService.createPaymentIntent(intentData);
      commit('SET_INTENT_SECRET', res.intentSecret);
      return res;
    } catch (error) {
      console.error(error);
    }
  }
};

export const mutations = {
  SET_CREDITS_DATA(state, creditsData) {
    state.creditsData = creditsData;
  },
  SET_STRIPE_PUBLIC_KEY(state, stripePublicKey) {
    state.stripePublicKey = stripePublicKey;
  },
  SET_INTENT_SECRET(state, intentSecret) {
    state.intentSecret = intentSecret;
  },
  SET_EU_COUNTRY(state, value) {
    state.isEUCountry = value;
  }
};
